import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { getSasToken } from "../../services/dms/dms-admin";
import Loader from "../common/Loader/Loader";

const FileViewer = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const { fileName } = useParams();

    useEffect(() => {
        sessionStorage.removeItem("userDocInfo");
        const params = new URLSearchParams(location.search);
        // const imgParam = decodeURIComponent(params.get('src'));
        const imgParam = decodeURIComponent(fileName);
        const accessibilityLevel = decodeURIComponent(params.get('accessibilityLevel'));

        const accessTokenObj = JSON.parse(sessionStorage.getItem("okta-token-storage") || "{}");
        const token = accessTokenObj?.idToken?.idToken || JSON.parse(localStorage.getItem("msal-token-storage"));
        if (token) {
            fetchFileToken(imgParam, accessibilityLevel);
        } else {
            sessionStorage.setItem(
                "userDocInfo",
                JSON.stringify({
                    userDocument: fileName,
                    accessibilityLevel: params.get('accessibilityLevel')
                })
            );

            navigate("/login");
        }
    }, [location, navigate]);

    const fetchFileToken = async (docUrl, accessibilityLevel) => {
        setLoading(true)
        const resp = await getSasToken(accessibilityLevel);
        if (resp && resp?.data) {
            const imageToken = resp?.data;
            const fileUrl = encodeURIComponent(`${docUrl}${imageToken}`);
            const fileExtension = docUrl?.split('.').pop().toLowerCase();

            let viewerUrl = "";
            if (fileExtension === "pdf") {
                viewerUrl = `${docUrl}${imageToken}`;
                setLoading(false);
                window.open(viewerUrl, '_self');
            } else if (["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(fileExtension)) {
                viewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${fileUrl}`;
                setLoading(false);
                window.open(viewerUrl, '_self');
            } else if (fileExtension === "csv") {
                try {
                    let newurl = `${docUrl}${imageToken}`;
                    fetch(newurl)
                        .then(response => response.text())
                        .then(text => {
                            const rows = text.trim().split('\n').map(row => row.split(','));
                            let html = `
                                <html>
                                    <head>
                                    <title>CSV Table</title>
                                    <style>
                                        table { border-collapse: collapse; }
                                        th, td { border: 1px solid black; padding: 4px; }
                                    </style>
                                    </head>
                                <body>
                                    <h2>CSV Table</h2>
                                    <table>
                            `;

                            rows.forEach((row, idx) => {
                                html += '<tr>';
                                row.forEach(cell => {
                                    const safeCell = cell.replace(/</g, '&lt;');
                                    html += idx === 0 ? `<th>${safeCell}</th>` : `<td>${safeCell}</td>`;
                                });
                                html += '</tr>';
                            });

                            html += `
                                </table>
                                </body>
                                </html>
                            `;

                            const blob = new Blob([html], { type: 'text/html' });
                            const blobUrl = URL.createObjectURL(blob);
                            setLoading(false);
                            window.open(blobUrl, '_self');
                        });
                } catch (error) {
                    console.error("Error loading CSV:", error);
                    setLoading(false);
                }
            } else {
                viewerUrl = `${docUrl}${imageToken}`;
                setLoading(false)
                window.open(viewerUrl, '_self');
            }

        }
    };

    return (
        <div>
            <Loader />
        </div>
    );
};

export default FileViewer;
